import { isDateOnlyPast } from '../../utils/date';

/**
 * When the inspector is asked about the site's estimated completion (Jim 8/9 + 10/13):
 * - 'past'    the date has gone by — a new date is required
 * - 'missing' no estimate yet — set one
 * - 'stale'   completion is within 90 days and nobody has confirmed it in the
 *             last 30 — still right, or a new date; beyond 90 days out, never
 */
export type EstCompletionPrompt = 'past' | 'missing' | 'stale' | null;

/** Only inside this many days of the estimated completion is anyone asked. */
export const EST_CONFIRM_EVERY_DAYS = 90;
/** Inside that window, ask monthly. */
export const EST_CONFIRM_NEAR_DAYS = 30;

export function estCompletionPrompt(
  site:
    | {
        estimated_end_date?: string | null;
        est_completion_confirmed_at?: string | null;
      }
    | null
    | undefined,
  now: Date = new Date()
): EstCompletionPrompt {
  if (!site) return null;
  if (!site.estimated_end_date) return 'missing';
  if (isDateOnlyPast(site.estimated_end_date)) return 'past';
  const confirmed = site.est_completion_confirmed_at
    ? new Date(site.est_completion_confirmed_at).getTime()
    : NaN;
  // Jim 10/21: more than three months out, never ask ("as long as it's three
  // months out or more, don't ask them"); inside three months, ask monthly.
  const DAY = 24 * 60 * 60 * 1000;
  const end = new Date(site.estimated_end_date).getTime();
  if (end - now.getTime() > EST_CONFIRM_EVERY_DAYS * DAY) return null;
  if (
    Number.isNaN(confirmed) ||
    now.getTime() - confirmed > EST_CONFIRM_NEAR_DAYS * DAY
  ) {
    return 'stale';
  }
  return null;
}
